<div class="relative flex h-24 " style="direction: ltr;">
  <div
    class="  flex text-xs flex-col text-center h-full min-w-32 w-fit justify-between items-between text-wrap font-bold mx-2"
  >
    <P>{{ upperLable }}</P>
    <P  class="mb-auto mt-3">{{ lowerLable }}</P>
  </div>
  <div class="flex justify-between my-auto h-14 w-full">
    <app-time-laps
      *ngFor="let timeLap of timeLaps"
      [timeLap]="timeLap"
    ></app-time-laps>
  </div>
  <div class="h-[1px] bg-gray-950 my-auto w-full absolute top-0 bottom-0"></div>
</div>
